// import React from "react";
// import DynamicTable from "../SharedFiles/CommonTable/dynamicTable";


// const ITTable = ({tableHeader,tablebody,onEdit,
//     setModalOpen,setTableBody}) => {
//         const onDelete = (action, rowIndex) => {
//             const updatedTableBody = tablebody.filter((_, index) => index !== rowIndex);
//             setTableBody(updatedTableBody);
//         }
//     return (
//         <div>
//             {tableHeader?.length > 0 &&  
//                 <DynamicTable
//                 header={tableHeader}
//                 tablebody={tablebody} 
//                 onEdit={onEdit}
//                 onDelete={onDelete}/>}
//         </div>
//     );
// }

// export default ITTable;

import React from "react";
import DynamicTable from "../../../SharedFiles/CommonTable/dynamicTable";
import { showDeleteConfirmation } from "../../../SharedFiles/WarningMessage/deleteWarning";

const ITTable = ({tableHeader,tablebody,onEdit,pageName,
    setScanModalVisible,setTableBody}) => {
        const onDelete = (action, rowIndex) => {
            showDeleteConfirmation(() => {
            const updatedTableBody = tablebody.filter((_, index) => index !== rowIndex);
            setTableBody(updatedTableBody);
            if (updatedTableBody.length === 0) {
                setScanModalVisible(true);
            }
        }); 
    };
  
    return (
        <div>
            {tableHeader?.length > 0 &&  
                <DynamicTable
                header={tableHeader}
                tablebody={tablebody} 
                onEdit={onEdit}
                onDelete={onDelete}
                pageName={pageName}
                />}

        </div>
    );
}

export default ITTable;